module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/special_offers/Bitmap1-14bcf603f035114d65f74b387be4a489.png";